import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { homeSearch } from './Reducers/HomeSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { booking } from './Reducers/Booking.reducer';
import { opticians } from './Reducers/Opticians.reducer';
import { search } from './Reducers/Search.reducer';
import { lensSpecifications } from './Reducers/LensSpecifications.reducer';

const staticReducers = {
    cart,
    quickSearch,
    homeSearch,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    booking,
    opticians,
    search,
    lightboxImages,
    lensSpecifications
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
